import HttpClient from '../../utils/HttpClient';

const httpClient = HttpClient.createInstance();

export const loadAgreement = id => httpClient.get('/agreements', { params: { id } });

export const counterSign = payload => httpClient.post('/agreements/counter-sign', payload);
